const toc = () => {
  const toc = document.getElementById('js-widget-toc');
  const toc_resources = document.getElementById('js-resources');

  if (toc !== null && toc_resources !== null) {
    // 目次の出力に使用する変数
    // eslint-disable-next-line
    let tocList = '<ol class="p-widget__toc-list">';
    // 目次の階層の判断に使用する変数
    let hierarchy: number;
    // h2・h3の判断に使用する変数
    // eslint-disable-next-line
    let element = 0;
    // 目次の項目数をカウントする変数
    // eslint-disable-next-line
    let count = 0;
    // サイドバー用の目次用divを作成
    const tocBody = document.createElement('div');
    // 作成したdivにid名を付与
    tocBody.setAttribute('class', 'p-widget__toc-body');
    //出力先の親要素を取得
    //親要素の最後にdivを配置
    toc.appendChild(tocBody);

    const resources_target = document.querySelectorAll('.p-resources__main > h2, .p-resources__block > h3');
    resources_target.forEach((value, i) => {
      count = i;
      value.id = 'chapter-' + count;

      // 現在のループで扱う要素を判断する条件分岐
      if (value.tagName === 'H2') {
        element = 0;
      } else {
        element = 1;
      }
      // 現在の状態を判断する条件分岐
      if (hierarchy == element) {
        // h2またはh3がそれぞれ連続する場合
        tocList += '</li>';
      } else if (hierarchy < element) {
        // h2の次がh3となる場合
        tocList += '<ol>';
        hierarchy = 1;
      } else if (hierarchy > element) {
        // h3の次がh2となる場合
        tocList += '</li></ol></li>';
        hierarchy = 0;
      } else if (count == 0) {
        // 最初の項目の場合
        hierarchy = 0;
      }

      // 目次の項目を作成。※次のループで<li>の直下に<ol>タグを出力する場合ががあるので、ここでは<li>タグを閉じていません。
      tocList += '<li><a href="#' + value.id + '">' + value.textContent?.replace(/【|】/g, '') + '</a>';
    });
    // 目次の最後の項目をどの要素から作成したかにより、タグの閉じ方を変更
    if (element == 0) {
      tocList += '</li></ol>';
    } else if (element == 1) {
      tocList += '</li></ol></li></ol>';
    }

    tocBody.innerHTML = tocList;
  }
};
export { toc };
